import { PROFILE, SUPPORTERS } from "@/lib/constants/api";
import API from "@/lib/constants/axios";
import { create } from "zustand";
import { PublicUserProfile } from "./types";
import { Supporter } from "@/store/supporters.store";

type publicProfileStoreType = {
  user: PublicUserProfile | null;
  supporters: { orders: Supporter[]; total: number } | null;
  fetchProfileByUserName: (
    username: string,
  ) => Promise<{ success: boolean } | undefined>;
  fetchSupporters: (userId: string) => void;
};

const usePublicProfileStore = create<publicProfileStoreType>((set, get) => ({
  user: null,
  supporters: null,
  fetchProfileByUserName: async (username: string) => {
    try {
      const res = await API.get(`${PROFILE}/${username}`);
      set({ user: res.data });
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  },
  fetchSupporters: async (userId: string) => {
    try {
      const res = await API.get(`${SUPPORTERS}/public/${userId}`, {
        params: {
          isActive: true,
        },
      });
      set({ supporters: res.data });
    } catch (error) {}
  },
}));

export default usePublicProfileStore;
